export class OTP {
  constructor(
    public id: number,
    public mobileNumber: string,
    public emailAddress: string,
    public requestCount: number
  ) { }
}
